import { formatOpeningHours } from '@doveit/hammer';
import { RealEstateAgent } from 'schema-dts';
import { RealEstateAgency } from '../../domain/graphcms';

export function getRealEstateAgencyStructuredData(
  name: string,
  locality: string,
  address: {
    locality: string,
    postalCode: string,
    streetAddress: string,
    region?: string,
    url: string,
  },
  phoneNumber?: string,
  openingHours?: RealEstateAgency['openingHours'],
): RealEstateAgent {
  const {
    locality: addressLocality,
    postalCode,
    streetAddress,
    region,
    url,
  } = address;

  return {
    '@type': 'RealEstateAgent',
    name,
    image: 'https://cdn.dove.it/static/assets/logo.png',
    url,
    telephone: phoneNumber,
    logo: {
      '@type': 'ImageObject',
      contentUrl: 'https://cdn.dove.it/static/assets/logo.png',
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'Italia',
      addressLocality,
      addressRegion: region || undefined,
      streetAddress,
      postalCode,
    },
    slogan: `Vendi casa a Zero Commissioni con Dove.it ${locality}`,
    openingHours: openingHours
      ? formatOpeningHours(openingHours, true, 'en')
      : ['Mo-Fr 09:30-19:30', 'Sa 09:30-13:30'],
  };
}
